// Funkcja pomocnicza do wysyłania żądań API z tokenem JWT
export const apiRequest = async (url, options = {}) => {
  const token = localStorage.getItem("access_token");
  
  const defaultHeaders = {
    "Content-Type": "application/json",
  };

  if (token) {
    defaultHeaders["Authorization"] = `Bearer ${token}`;
  }

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  const response = await fetch(url, config);
  
  if (response.status === 401) {
    // Token wygasł lub jest nieprawidłowy
    localStorage.removeItem("access_token");
    localStorage.removeItem("loggedUser");
    window.location.reload();
    throw new Error("Unauthorized");
  }
  
  if (response.status === 403) {
    throw new Error("Brak uprawnień");
  }

  return response;
};

// Funkcja do sprawdzania czy użytkownik jest zalogowany
export const isAuthenticated = () => {
  return localStorage.getItem("access_token") !== null;
};

// Funkcja do wylogowania
export const logout = async () => {
  try {
    // Wywołaj endpoint do logowania wylogowania
    await apiRequest("/api/logout/", {
      method: "POST",
    });
  } catch (error) {
    console.error("Błąd przy logowaniu wylogowania:", error);
  } finally {
    // Zawsze wyczyść localStorage, nawet jeśli logowanie wylogowania się nie udało
    localStorage.removeItem("access_token");
    localStorage.removeItem("loggedUser");
    localStorage.removeItem("lastActivity");
  }
}; 